import * as React from 'react';

import { cn, Col } from '@rematter/ui-web';

export type ContentWithSideMenuProps = {
  menu: { label: string; content: React.ComponentType }[];
};

export const ContentWithSideMenu = ({ menu }: ContentWithSideMenuProps) => {
  const [selectedMenuItem, setSelectedMenuItem] = React.useState(menu[0]);

  return (
    <div className="@ContentWithSideMenu grid h-full grid-cols-[250px_1fr]">
      <Col className={'h-full gap-px overflow-y-auto py-5 pl-5'}>
        {menu.map((item) => (
          <button
            key={item.label}
            onClick={() => setSelectedMenuItem(item)}
            className={cn(
              'cursor-pointer rounded-sm border-none px-3 py-1.5 text-left text-sm opacity-50 outline-none',
              'hover:bg-current/7 hover:opacity-100',
              selectedMenuItem.label === item.label &&
                'bg-current/7 font-semibold opacity-100',
            )}
          >
            {item.label}
          </button>
        ))}
      </Col>
      <div className={'h-full overflow-y-auto'}>
        <selectedMenuItem.content />
      </div>
    </div>
  );
};
